import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { useTranslation } from "react-i18next";

const LocationForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpForm.Input
                label={t('location.location.name')}
                name="name"
                rules={[{ required: true, message: t('location.location.nameRequired') }]}
            />
            <OpForm.Input
                label={t('location.location.description')}
                name="description"
            />
        </>
    );
};

export default LocationForm;
